module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Black.a60431ba.otf";